import React, {createContext} from 'react';
import axios from 'axios';

export const UserContext = createContext();
var apiUrl = process.env.REACT_APP_API_URL_START + window.location.hostname.substr(window.location.hostname.split('.')[0].length) + process.env.REACT_APP_API_URL_END;

class UserContextProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            client: [],
            user:    null,
            message: {text: undefined, severity: undefined},
        };
    }

    componentDidMount() {
        this.checkLogin();
        this.readClient();
    }

    checkLogin() {
        try {
            const todoAppUser = document.cookie.split('; ')
                .find(row => row.startsWith('TodoAppUser'))
                .split('=')[1];
            if (todoAppUser) {
                this.setState({user: todoAppUser}, () => {
                });
            } else {
                document.cookie = 'TodoAppUser=null';
            }
        } catch (e) {
            document.cookie = 'TodoAppUser=null';
        }
    }

    readClient() {
        axios.get(apiUrl+'/client',{
            withCredentials:true
        })
            .then(response => {
                this.setState({
                    client: response.data,
                });

            }).catch(error => {
            console.error(error);
        });
    }

    doSignOut(){
        localStorage.clear();
        axios.get(apiUrl+'/logout', {
            timeout: 3000,
            withCredentials:true
        })
            .then(response =>{
                window.location.reload();
            }).catch(error => {
            console.error(error)
            });
    }


    amILoggedIn(){
        return (localStorage.getItem('user') !== null);
    }

    parseQuery(queryString) {
        var query = {};
        var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
        return query;
    }


    /**
     * @param {Object} data
     * @param {string} data.email
     * @param {string} data.password
     */
    login(data) {







        try {

            axios.post(apiUrl+'/login', data, {
                withCredentials:true,
                timeout: 3000}).then(r => {
                localStorage.setItem('user', r.data.user);
                this.setState({
                    user:    r.data.user,
                    message: {
                        text:     'You have successfully logged as ' + r.data.user.username + '! You will be redirected to the homepage shortly...',
                        severity: 'success',
                    },
                });

                var query = this.parseQuery(window.location.search.substring(1));
                let runU = '';
                if(query['usremail'] !== undefined){
                    runU = '?_switch_user='+query['usremail'];
                    axios.get(apiUrl+'/client/pips'+runU, {
                        withCredentials:true,
                        timeout: 3000}).then(r=>{
                        window.location.href = '/home';
                    });
                }
                else{
                    window.location.href = '/home';
                }




            });

        } catch (e) {
            if (e.message.includes('timeout')) {
                this.setState({message: {text: 'The request to the server has timed out.', severity: 'error'}});
            } else {
                this.setState({
                    message: {
                        text:     e.message + ' Please check if you filled out the form correctly.',
                        severity: 'error',
                    },
                });
            }
        }


    }

    render() {
        return (
            <UserContext.Provider value={{
                ...this.state,
                login: this.login.bind(this),
                checkLogin: this.checkLogin.bind(this),
                doSignOut: this.doSignOut.bind(this),
                amILoggedIn: this.amILoggedIn.bind(this),
            }}>
                {this.props.children}
            </UserContext.Provider>
        );
    }
}

export default UserContextProvider;